module.exports = __webpack_public_path__ + "img/glasses-9-2.db24b884.svg";